module.exports = __webpack_public_path__ + "img/零食4.e3157f0f.png";